import { useMemo } from 'react';
import { useBehavior } from '../extensions/hooks/useBehavior';
import { CardAction } from '../extensions/constants/BehaviorTypes';
import { useAssociatedObjectsCardContext } from '../context/AssociatedObjectsCardContext';
import { useIsEmbeddedContextV2 } from 'customer-data-sidebar/universal/context/IsEmbeddedContextV2';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const AssociatedObjectsCardActions = () => {
  var _associationTypesData;
  const {
    associationsData,
    associationTypesData,
    cardId,
    hasScope,
    isUngated,
    isEmbedded,
    objectId,
    objectTypeId: fromObjectTypeId,
    objectTypePermissions,
    readOnly,
    toObjectTypeId,
    userPermissions,
    onRefetchLegacySidebar,
    refetchObjectData
  } = useAssociatedObjectsCardContext();
  const {
    allowActions
  } = useIsEmbeddedContextV2();
  const CardActionComponent = useBehavior(CardAction, toObjectTypeId, hasScope, isUngated);
  const associatedObjectsIds = useMemo(() => {
    var _associationsData$imp, _associationsData$imp2;
    return (_associationsData$imp = (_associationsData$imp2 = associationsData.impliedUnlabeledAssociationObjects) === null || _associationsData$imp2 === void 0 ? void 0 : _associationsData$imp2.results.map(searchResult => `${searchResult.id}`)) !== null && _associationsData$imp !== void 0 ? _associationsData$imp : [];
  }, [associationsData]);
  const unlabeledAssociationType = associationTypesData.unlabeledAssociationType || ((_associationTypesData = associationTypesData.associationTypes) === null || _associationTypesData === void 0 ? void 0 : _associationTypesData[0]);

  // Allow embedded cards to show actions
  if (isEmbedded && !allowActions || readOnly) {
    return null;
  }
  if (!CardActionComponent || !unlabeledAssociationType || associationTypesData.associationTypesError || associationsData.associationsDataError) {
    return null;
  }
  const {
    associationTypeId,
    associationCategory
  } = unlabeledAssociationType;
  const associationPrimaryDisplayLabel = unlabeledAssociationType && unlabeledAssociationType.toObjectTypeDefinition && unlabeledAssociationType.toObjectTypeDefinition.singularForm;
  const canCreate = objectTypePermissions !== null && objectTypePermissions.currentUserCanCreate;
  const canEditAssociations = userPermissions.currentUserCanEditAssociations;
  const canEditAssociation = canEditAssociations || canCreate;
  const canEditAssociationMessageOverride = !canEditAssociation ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "cardAssociatedObjects.AssociateObjectButton.tooltip.permissionsTooltipTextV2"
  }) : undefined;
  return /*#__PURE__*/_jsx(CardActionComponent, {
    cardId: cardId,
    canEditAssociation: canEditAssociation,
    canEditAssociationMessageOverride: canEditAssociationMessageOverride,
    fromObjectTypeId: fromObjectTypeId,
    toObjectTypeId: toObjectTypeId,
    fromObjectId: objectId,
    associatedObjectsIds: associatedObjectsIds,
    associationTypeData: {
      associationCategory,
      associationTypeId,
      associationPrimaryDisplayLabel
    },
    onRefetchLegacySidebar: onRefetchLegacySidebar,
    refetchObjectData: refetchObjectData,
    isUngated: isUngated,
    hasScope: hasScope,
    userPermissions: userPermissions,
    objectTypePermissions: objectTypePermissions
  });
};
export default AssociatedObjectsCardActions;